













import { Vue, Component } from 'vue-property-decorator';

@Component
export default class TWDPromotion extends Vue {
  desktopBannerImage =
    'https://static.gala.games/images/banners/the-walking-dead/twd-banner-desktop.jpg';
  mobileBannerImage =
    'https://static.gala.games/images/banners/the-walking-dead/twd-banner-mobile.jpg';

  goTo(route: string) {
    this.$router.push(route);
  }
}
